import axios from 'axios';

import { ImportQueue } from 'components/types';

import { IMPORT_QUEUE } from '../endpoints';

export type GetImportQueueOptions = {
  params: {
    tenantId?: number;
    start?: string;
    end?: string;
  };
  signal?: AbortSignal;
};

export const getImportQueue = ({ params, signal }: GetImportQueueOptions) =>
  axios.get<ImportQueue>(IMPORT_QUEUE, {
    signal,
    params
  });
